import { OptimizationMode as T } from "./optimizer.service.js";
const S = 50;
async function at(i, l) {
  if (!i)
    throw new Error("Optimizer service is not initialized");
  const { medias: O, refineSpend: J } = i, b = JSON.parse(i.recentYearSpends), { startDate: p, endDate: m } = l.getPeriod(b), k = JSON.parse(i.recentYearMediumTotalSpends), W = await i.getMediasLimits();
  let I = Promise.resolve();
  const B = async (t) => {
    let e;
    const a = new Promise((r) => {
      e = r;
    }), s = I;
    I = a, await s;
    try {
      return await t();
    } finally {
      e();
    }
  };
  let x = 0, y = null, D = null;
  const A = async () => await J(Object.values(k).reduce((t, e) => t + e, 0)), L = await A(), U = () => {
    const t = i.diminishing;
    return O.reduce(
      (e, a, s) => (t[s] !== void 0 && (e[a] = t[s]), e),
      {}
    );
  }, G = () => JSON.parse(i.allocation), f = async () => {
    await i.resetOptimisationRules();
  }, E = async (t) => {
    await i.updateRules(t);
  }, j = async (t) => {
    const e = t.filter((a) => a.type === "Allowed weekdays");
    for (const a of e)
      try {
        const s = JSON.parse(a.value);
        Array.isArray(s) && s.length === 7 && await i.setAllowedWeekdays(a.channel, s);
      } catch {
      }
  }, v = async () => await i.readMessages(), g = (t) => {
    if (t)
      return t instanceof Date ? t : l.parseDate(t);
  }, $ = (t) => {
    const e = String(t.getDate()).padStart(2, "0"), a = String(t.getMonth() + 1).padStart(2, "0"), s = t.getFullYear();
    return `${e}-${a}-${s}`;
  }, V = (t, e) => {
    const a = g(t);
    if (!a || !e || e <= 0)
      return { startDate: p, endDate: m };
    const s = new Date(a);
    return s.setDate(s.getDate() + e - 1), {
      startDate: $(a),
      endDate: $(s)
    };
  }, M = async (t, e, a, s) => {
    const r = a?.configRules || [], n = a?.variables;
    return r.length === 0 && (!n || Object.keys(n).length === 0) ? s() : B(async () => {
      const o = V(t, e), c = l.prepareRules(n, r, o.startDate, o.endDate);
      await f();
      try {
        if (c.length > 0) {
          await j(c);
          const w = c.filter((R) => R.type !== "Allowed weekdays");
          w.length > 0 && await E(w);
        }
        return await s();
      } finally {
        await f();
      }
    });
  }, _ = async (t, e, a) => {
    const s = a?.scalePeriods ?? !0;
    return await M(t, e, a, async () => {
      const r = g(t), [n, o] = await i.getKPILimits(r, e, s);
      return { lower: n, upper: o };
    });
  }, K = async (t, e, a) => await M(t, e, a, async () => {
    const s = g(t), [r, n] = await i.getBudgetLimits(s, e);
    return {
      lower: r + S,
      upper: n
    };
  }), N = async (t, e, a) => {
    const s = a?.scalePeriods ?? !0;
    return await M(t, e, a, async () => {
      const r = g(t), [n, o] = await i.getTotalKPILimits(r, e, s);
      return { lower: n, upper: o };
    });
  }, q = async (t, e) => {
    const a = g(t);
    return !a || !e || e <= 0 ? {} : await i.getChannelPeriodFractions(a, e);
  }, H = async (t, e, a, s) => t === "budget" ? K(e, a, s) : t === "total_kpi" ? N(e, a, s) : _(e, a, s), Q = async (t, e, a, s, r) => {
    const n = ++x;
    if (D = n, D !== n)
      throw new Error(`Optimization ${n} was batched`);
    y = n, D = null;
    let o = T.BUDGET;
    s === "media_kpi" ? o = T.MEDIA_KPI : s === "total_kpi" && (o = T.TOTAL_KPI);
    try {
      const c = await i.createOptimisedPlans(
        t,
        e ? l.parseDate(e) : void 0,
        a ? l.parseDate(a) : void 0,
        o,
        r
      );
      if (y !== n)
        throw new Error(`Optimization ${n} was superseded`);
      return c;
    } finally {
      y === n && (y = null);
    }
  }, X = (t) => ({
    lowestBudgetTrustworthiness: t * (1 - l.budgetTrustworthinessThreshold),
    highestBudgetTrustworthiness: t * (1 + l.budgetTrustworthinessThreshold)
  });
  return {
    getOptimizedPlan: async (t) => B(async () => {
      const {
        budget: e,
        variables: a,
        configRules: s = [],
        startDate: r,
        endDate: n,
        optimizationBase: o
      } = t;
      await f();
      let { budget: c, budgetError: w } = await l.checkBudget(e, i, L, o);
      const R = r && n ? Math.max(
        1,
        Math.round(
          (l.parseDate(n).getTime() - l.parseDate(r).getTime()) / (1e3 * 60 * 60 * 24)
        ) + 1
      ) : void 0, P = l.prepareRules(a, s, r || p, n || m);
      if (P.length > 0) {
        await j(P);
        const d = P.filter((h) => h.type !== "Allowed weekdays");
        d.length > 0 && await E(d);
      }
      const Y = P.some((d) => d.type === "Set active days to"), [C, u] = await Promise.all([
        i.getMediasLimits(),
        H(o || "budget", r, R, { scalePeriods: !Y })
      ]);
      c < u.lower ? (w = `Entered ${o === "budget" ? "budget" : "target"} was too low. Changed it to lowest possible which is ${u.lower}.`, c = u.lower) : c > u.upper && (w = `Entered ${o === "budget" ? "budget" : "target"} was too high. Changed it to highest possible which is ${u.upper}.`, c = u.upper);
      const Z = await Q(c, r, n, o, !Y);
      let F = C;
      if (r && n) {
        const d = l.getDurationRatio(r, n);
        F = C.map((h) => ({
          ...h,
          lowerLimit: Math.round(h.lowerLimit * d),
          upperLimit: Math.round(h.upperLimit * d)
        }));
      }
      return {
        ...l.buildOptimizationOutput({ plan: Z, medias: O, recentYearSpends: b }),
        ...X(L),
        recentYearMediumTotalSpends: k,
        recentYearSpends: b,
        budget: c,
        defaultBudget: L,
        lowestBudget: u.lower,
        highestBudget: u.upper,
        budgetError: w,
        startDate: p,
        endDate: m,
        mediaLimits: F,
        investmentStep: i.investmentStep,
        naturalDemand: l.formatNaturalDemand(await i.getNaturalDemandData())
      };
    }),
    messages: v,
    getDiminishingPoints: U,
    getInitialAllocation: G,
    resetOptimisationRules: f,
    getDefaultBudget: A,
    getBudgetLimits: K,
    getKPILimits: _,
    getTotalKPILimits: N,
    getChannelPeriodFractions: q,
    startDate: p,
    endDate: m,
    getOptimizerVersion: () => i.getOptimizerVersion(),
    getActiveDaysPerMedium: () => i.getActiveDaysPerMedium(),
    getBaseProjectMediaLimits: () => W,
    medias: O
  };
}
export {
  at as createOptimizerServiceManager
};
